/**
 * Created by BlueFocus5 on 2016-11-07.
 */



export let DictionaryTrans = {
  t: function(name){



    if ( this.trans && this.trans.get(name) )
    {
      return this.trans.get(name);
    }
    if ( this.trans && !this.trans[name] )
    {
      if ( Object.keys(this.trans).length > 0 )
      {
      // console.log('No found: ',name,Object.keys(this.trans).length);
      }
    }

    // todo : ask backend about it

    return name;
  },

  tp : function(product,currentLang,phrase){


    let trans = product.translations;
    for ( let i in trans )
    {
      if ( trans[i].languageCode == currentLang ) 
      {
        return trans[i][phrase];
      }
    }

    return product[phrase]; // default value

  }



};



export function autobind(methodNames){
  return {
    componentWillMount: function(){
      methodNames.forEach((name) => {
        this[name] = this[name].bind(this);
      });
    }
  };
}





